import { FiEye, FiActivity, FiGift } from 'react-icons/fi';

export const serviceCategories = [
  {
    id: 'extensions',
    titleEn: 'Eyelash Extensions',
    titleEs: 'Extensiones de Pestañas',
    icon: FiEye,
    descriptionEn: 'Premium mink and silk fibers applied 1-by-1 or volume.',
    descriptionEs: 'Fibras premium de visón y seda aplicadas 1x1 o volumen.',
    items: [
      {
        nameEn: "Classic Lash Extensions (1x1)",
        nameEs: "Extensiones Clásicas (1x1)",
        priceMXN: 500,
        priceUSD: 30,
        descEn: "One extension per natural lash. Natural mascara effect.",
        descEs: "Una extensión por pestaña natural. Efecto rímel natural."
      },
      {
        nameEn: "Hybrid Lash Extensions",
        nameEs: "Extensiones Híbridas",
        priceMXN: 700,
        priceUSD: 40,
        descEn: "Mix of Classic + Volume. Textured, fluffy look.",
        descEs: "Mezcla de Clásicas + Volumen. Look texturizado."
      },
      {
        nameEn: "Russian Volume (3D-5D)",
        nameEs: "Volumen Ruso (3D-5D)",
        priceMXN: 900,
        priceUSD: 50,
        descEn: "Full, dark, dramatic density.",
        descEs: "Densidad completa, oscura y dramática."
      },
      {
        nameEn: "Mega Volume (6D-8D+)",
        nameEs: "Mega Volumen (6D-8D+)",
        priceMXN: 1200,
        priceUSD: 70,
        descEn: "Maximum density & drama. Blackout effect.",
        descEs: "Máxima densidad y drama. Efecto blackout."
      },
      {
        nameEn: "Wet Look Effect",
        nameEs: "Efecto Mojado (Wet Look)",
        priceMXN: 850,
        priceUSD: 50,
        descEn: "TRENDING. Spiky, textured, slicked appearance.",
        descEs: "TENDENCIA. Apariencia puntiaguda y texturizada."
      },
      {
        nameEn: "Wispy/Feathered Lashes",
        nameEs: "Pestañas Wispy/Plumosas",
        priceMXN: 800,
        priceUSD: 50,
        descEn: "Kim K style. Soft, non-uniform spikes.",
        descEs: "Estilo Kim K. Puntas suaves no uniformes."
      },
      {
        nameEn: "Anime/Manga Effect",
        nameEs: "Efecto Anime/Manga",
        priceMXN: 950,
        priceUSD: 50,
        descEn: "Doll-like, dramatic eye spikes.",
        descEs: "Puntas dramáticas estilo muñeca."
      },
      {
        nameEn: "Foxy Eye Lift",
        nameEs: "Ojo de Zorro",
        priceMXN: 900,
        priceUSD: 50,
        descEn: "Elongated outer corner styling.",
        descEs: "Estilo alargado en la esquina exterior."
      },
      {
        nameEn: "Ombré Lashes",
        nameEs: "Pestañas Ombré",
        priceMXN: 1000,
        priceUSD: 60,
        descEn: "Gradient color. Dark roots, light tips.",
        descEs: "Color degradado. Raíces oscuras, puntas claras."
      },
      {
        nameEn: "Colored Extensions",
        nameEs: "Extensiones de Color",
        priceMXN: 800,
        priceUSD: 50,
        descEn: "Blue, Purple, Pink, or Mixed.",
        descEs: "Azul, Morado, Rosa o Mixto."
      },
      {
        nameEn: "Mink-Effect Luxury",
        nameEs: "Lujo Efecto Visón",
        priceMXN: 950,
        priceUSD: 55,
        descEn: "Ultra soft, premium finish.",
        descEs: "Acabado premium ultra suave."
      },
      {
        nameEn: "Refill (2 Weeks)",
        nameEs: "Retoque (2 Semanas)",
        priceMXN: 350,
        priceUSD: 20,
        descEn: "Quick touch-up maintenance.",
        descEs: "Mantenimiento rápido."
      },
      {
        nameEn: "Refill (3 Weeks)",
        nameEs: "Retoque (3 Semanas)",
        priceMXN: 500,
        priceUSD: 30,
        descEn: "Standard refill.",
        descEs: "Retoque estándar."
      },
      {
        nameEn: "Refill (4 Weeks)",
        nameEs: "Retoque (4 Semanas)",
        priceMXN: 650,
        priceUSD: 40,
        descEn: "Extended maintenance.",
        descEs: "Mantenimiento extendido."
      },
      {
        nameEn: "Safe Removal",
        nameEs: "Retiro Seguro",
        priceMXN: 150,
        priceUSD: 10,
        descEn: "Chemical removal with care.",
        descEs: "Retiro químico con cuidado."
      }
    ]
  },
  {
    id: 'natural',
    titleEn: 'Natural & Brows',
    titleEs: 'Naturales y Cejas',
    icon: FiActivity,
    descriptionEn: 'Enhance your natural beauty.',
    descriptionEs: 'Realza tu belleza natural.',
    items: [
      {
        nameEn: "Lash Lift",
        nameEs: "Lifting de Pestañas",
        priceMXN: 450,
        priceUSD: 30,
        descEn: "Semi-permanent curl.",
        descEs: "Rizo semipermanente."
      },
      {
        nameEn: "Lash Lift + Tint",
        nameEs: "Lifting + Tinte",
        priceMXN: 650,
        priceUSD: 40,
        descEn: "Curl + Darkening.",
        descEs: "Rizo + Oscurecimiento."
      },
      {
        nameEn: "Brow Lamination",
        nameEs: "Laminación de Cejas",
        priceMXN: 350,
        priceUSD: 20,
        descEn: "Fluffy, brushed-up brows.",
        descEs: "Cejas esponjosas y peinadas."
      },
      {
        nameEn: "Brow Lam + Tint",
        nameEs: "Laminación + Tinte",
        priceMXN: 500,
        priceUSD: 30,
        descEn: "Shape and definition.",
        descEs: "Forma y definición."
      },
      {
        nameEn: "HD Brow Design",
        nameEs: "Diseño de Ceja HD",
        priceMXN: 700,
        priceUSD: 40,
        descEn: "Mapping, wax, tint, style.",
        descEs: "Mapeo, cera, tinte, estilo."
      },
      {
        nameEn: "Henna Brows",
        nameEs: "Cejas con Henna",
        priceMXN: 300,
        priceUSD: 20,
        descEn: "Natural long-lasting tint.",
        descEs: "Tinte natural duradero."
      }
    ]
  },
  {
    id: 'packages',
    titleEn: 'Packages & Combos',
    titleEs: 'Paquetes y Combos',
    icon: FiGift,
    descriptionEn: 'Save money with our bundles.',
    descriptionEs: 'Ahorra dinero con nuestros paquetes.',
    items: [
      {
        nameEn: "Classic + Brow Lam",
        nameEs: "Clásicas + Lam Cejas",
        priceMXN: 1200,
        priceUSD: 70,
        descEn: "Full set + Brow Lamination.",
        descEs: "Set completo + Laminación."
      },
      {
        nameEn: "Volume + HD Brows",
        nameEs: "Volumen + Cejas HD",
        priceMXN: 1500,
        priceUSD: 90,
        descEn: "Volume Set + HD Design.",
        descEs: "Set Volumen + Diseño HD."
      },
      {
        nameEn: "Bridal Package",
        nameEs: "Paquete de Novia",
        priceMXN: 2500,
        priceUSD: 140,
        descEn: "Trial + Wedding Day.",
        descEs: "Prueba + Día de Boda."
      },
      {
        nameEn: "Girls Day Out (3+)",
        nameEs: "Día de Chicas (3+)",
        priceMXN: 3000,
        priceUSD: 170,
        descEn: "Group discount per person.",
        descEs: "Descuento grupal por persona."
      }
    ]
  }
];